import React from 'react';
import {
    makeStyles,
    createStyles,
    Grid,
    Paper,
    Table,
    withStyles,
    TableCell,
    TableRow,
    TableContainer,
    TableHead,
    TableBody,
    IconButton,
    CircularProgress,
    Button,
    Card,
    CardContent,
    TextField,
    Switch,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import { useSelector } from 'react-redux';
import { format, addDays } from "date-fns";
import ICourseGradeBook from '../../../../interfaces/setup/academics/ProgramDefinition/ICourseGradeBook';
import  IGradeScale  from "../../../../interfaces/setup/grades/ComponentTypes/IGradeScale";
import  IGradeScaleDescriptionDetail  from "../../../../interfaces/setup/grades/ComponentTypes/IGradeScaleDescriptionDetail";
import * as componentTypeApi from "../../../../api/setup/grades/componentTypesApi";
import InputField from '../../../../components/_Layout/Inputs/InputField';
import CustomCardTitle from '../../../../interfaces/common/card/CustomCardTitle';
import { getCourseGradeBooks } from '../../../../api/setup/academics/courses';
import { InputType } from '../../../../constants/uiConstants/inputConstants';
import { EmptyGuid } from '../../../../utils/constants';
import { FieldError, useForm, FormContext } from 'react-hook-form';
import { CustomSnackBarProps } from '../../../../interfaces/common/CustomSnackBarProps';
import IGradeSystemDetail from '../../../../interfaces/setup/grades/ComponentTypes/IGradeSystemDetail';
import ProgressSaveButton from '../../../../components/_Layout/Buttons/ProgressSaveButton';
import LibraryAddOutlinedIcon from '@material-ui/icons/LibraryAddOutlined';
import GradeSystemDetailAutoComplete from '../../../../components/AutoComplete/GradeSystemDetailAutoComplete';
import MultiCampusAutoComplete from '../../../../components/AutoComplete/MultiCampusAutoComplete';
import StatusAutoComplete from "../../../../components/AutoComplete/StatusAutoComplete";
import GradeSystemAutoComplete from "../../../../components/AutoComplete/GradeSystemAutoComplete";
import AddNewComponent from '../../academics/ProgramProgramVersion/ProgramVersion/Definition/AddCoursePopUP/AddNewComponent';
import { Guid } from '../../../../utils/guid';
const ThemeTextField = withStyles((theme: any) =>
  createStyles({
    root: {},
  })
)(TextField);


const StyledTableCell = withStyles((theme: any) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.site.secondary,
            fontSize: 17,
            color: theme.palette.black,
            fontWeight: 'bold',
            textAlign: 'left',
            boxShadow: '1px 1px 0px 0px rgba(0,0,0,0.2)',
            '&:first-child': {
                minWidth: theme.spacing(30),
                padding: theme.spacing(0, 1)
            }
        },
        body: {
            fontSize: 16,
            color: theme.palette.black,
            fontWeight: 400,
            cursor: 'pointer',
            textAlign: 'left',
            padding: theme.spacing(1),
            '&:first-child': {
                minWidth: theme.spacing(30),
                padding: theme.spacing(0, 1)
            }
        },
    }),
)(TableCell);

const StyledTableRow = withStyles((theme: any) =>
    createStyles({
        root: {
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.site.secondary,
            },
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.white,
            },
            '&:hover': {
                backgroundColor: theme.palette.site.secondary,
            }
        },
        body: {
            cursor: 'pointer'
        }
    }),
)(TableRow);

const useStyles = makeStyles((theme: any) =>
    createStyles({
        cardTitle: {
            fontSize: 17,
            color: theme.palette.black,
            fontWeight: 'bold',
            backgroundColor: theme.palette.site.secondary,
            padding: theme.spacing(0)
        },
        headerText: {
            float: 'left',
            padding: theme.spacing(1.5),
        },
        cardContent: {
            padding: theme.spacing(1, 3),
            height: '100%',
        },
        saveButton: {
            width: 90,
        },
        tableContainer: {
            maxHeight: '400px'
        },
        table: {
            width: '100%',
        },
        iconColor: {
            color: theme.palette.black
        },
        searchField: {
            '&::placeholder': {
                color: theme.palette.black
            }
        },
        selectionCheckBox: {
            padding: theme.spacing(0)
        },
        preLoaderCell: {
            textAlign: 'center',
            padding: theme.spacing(1)
        },
        dialogCloseButton: {
            float: "right",
        },
        courseSelectionCell: {
            color: theme.palette.paperSummarySchedulerTitle,
            cursor: 'pointer',
            fontWeight: 500
        }
    })
);
type GradeSystemDetailGridProps = {
    components: IGradeSystemDetail[];
    campusId?: string;
    grdSystemId?: string;
    addGradeSystem: (component: IGradeSystemDetail) => void;
    updateGradeSystem: (component: IGradeSystemDetail, index: number) => void;
    deleteGradeSystem: (index: number) => void;
};

const GradeSystemDetailGrid = (
    props: Readonly<GradeSystemDetailGridProps>
) => {
    const classes = useStyles({});
    const [isLoading] = React.useState<boolean>(false);
    const [grdSystemDetail, setgrdSystemDetail] = React.useState<IGradeSystemDetail[]>(props.components);
    const [newGrdSystemDetail, setNewGrdSystemDetail] = 
    React.useState<IGradeSystemDetail>(
        { campusId:EmptyGuid,
            grade:"",
            gpa:0,
            isCreditsEarned:false,
            isCreditsAttempted:false,
            isTransferGrade: false,
            isInGpa: false,
            isInSap: false,
            isPass: false,
            isIncomplete: false,
            isDefault:false,
            isDrop: false
    });
    const [rowToEdit, setEditIndex] = React.useState<number>();
    const data = useForm<any>({ mode: "onBlur" });
    const [tempData, setTempData] = React.useState<IGradeSystemDetail>();

    const setRowToEdit = (index?: number) => {
        setEditIndex(index);
        if (index && (index - 1) < grdSystemDetail.length) {
            setTempData({ ...(grdSystemDetail[index - 1]) });
        }
    }

    const handleNewComponentFieldChange = (fieldId: keyof IGradeSystemDetail, value: any, index: number = 0) => {
        if (index === 0) {
            let updatedModel = newGrdSystemDetail;
            (updatedModel as any)[fieldId] = value;
            setNewGrdSystemDetail({ ...updatedModel });
        }
        else if (grdSystemDetail.length >= index) {
             grdSystemDetail[index - 1][fieldId] = value;
            setgrdSystemDetail([...grdSystemDetail]);
        }
        data.setValue(`${fieldId}[${index}]`, value);
        data.triggerValidation(`${fieldId}[${index}]`);
    };

    const onComponentSave = async (index: number) => {
        const valid = await data.triggerValidation([ `gpa[${index}]`]);
        newGrdSystemDetail.grdSystemId =props.grdSystemId;
        
            if (index === 0) {
                if (valid && newGrdSystemDetail.grade!="" && newGrdSystemDetail.gpa!=undefined && newGrdSystemDetail.gpa>=0){
                    props.addGradeSystem(newGrdSystemDetail);
                    setNewGrdSystemDetail({ gpa:0,campusId:EmptyGuid,grade:"" });

                }
            }
            else {
                if(grdSystemDetail[index - 1].grade!="" && grdSystemDetail[index - 1].gpa!=undefined)
                props.updateGradeSystem(grdSystemDetail[index - 1], index - 1);
            }
            setRowToEdit(undefined);
            setTempData(undefined);

        
    }

    const onComponentDelete = (index: number) => {
        if (index < grdSystemDetail.length) {
            props.deleteGradeSystem(index);
        }
    }

    const onComponentCancel = () => {
        if (rowToEdit && tempData) {
            grdSystemDetail[rowToEdit - 1] = { ...tempData };
            setgrdSystemDetail([...grdSystemDetail]);
            setRowToEdit(undefined);
            setTempData(undefined);

        }
    }

    React.useEffect(() => {
        setgrdSystemDetail(props.components);
        setNewGrdSystemDetail({});
    }, [props.components])

    return (
      <div style={{paddingTop:'10px'}}>
        <FormContext {...data}>
            <form>
                
                        <TableContainer component={Paper} style={{width:'100%'}}>
                            <Table className={classes.table} size="small"
            aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell colSpan={1}>Grade</StyledTableCell>
                                        <StyledTableCell colSpan={1}>GPA</StyledTableCell>
                                        <StyledTableCell colSpan={1}>Credits Earned</StyledTableCell>
                                        <StyledTableCell colSpan={1}>Credits Attempted</StyledTableCell>
                                        <StyledTableCell colSpan={1}>Transfer Grade</StyledTableCell>
                                        <StyledTableCell colSpan={1}>In GPA</StyledTableCell>
                                        <StyledTableCell colSpan={1}>In SAP</StyledTableCell>
                                        <StyledTableCell colSpan={1}>Pass</StyledTableCell>
                                        <StyledTableCell colSpan={1}>Incomplete</StyledTableCell>
                                        <StyledTableCell colSpan={1}>Default</StyledTableCell>
                                        <StyledTableCell colSpan={1}>Drop</StyledTableCell>
                                        <StyledTableCell colSpan={1}></StyledTableCell>
                                        <StyledTableCell colSpan={1}></StyledTableCell>
                                        <StyledTableCell colSpan={1}></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        
                                        <StyledTableCell colSpan={1}>
                                        
                                            <InputField
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                type={InputType.TEXT}
                                                id="grade[0]"
                                                name="grade[0]"
                                                defaultValue={newGrdSystemDetail.grade}
                                                onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                                    handleNewComponentFieldChange("grade", e.target.value);
                                                }}
                                                error={!!(data.errors.grade && data.errors.grade[0])}
                                                inputProps={{ maxLength: 10 }}
                                                helperText={
                                                    (data.errors.grade)
                                                        ? "Grade is required." : undefined
                                                }
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>

                                            <InputField
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                type={InputType.NUMBER}
                                                decimal
                                                id="gpa[0]"
                                                name="gpa[0]"
                                                defaultValue={newGrdSystemDetail.gpa}
                                                onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                                    handleNewComponentFieldChange("gpa", e.target.value);
                                                }}
                                                error={!!(data.errors.gpa && data.errors.gpa[0])}
                                                inputRef={data.register({ required: true })}
                                                helperText={
                                                    (data.errors.gpa && data.errors.gpa[0])

                                                        ? (data.errors.gpa[0] as FieldError).message
                                                            : undefined
                                                }
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isCreditsEarned}
                                                name="isCreditsEarned"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isCreditsEarned', checked)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isCreditsAttempted}
                                                name="isCreditsAttempted"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isCreditsAttempted', checked)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isTransferGrade}
                                                name="isTransferGrade"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isTransferGrade', checked)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isInGpa}
                                                name="isInGpa"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isInGpa', checked)}
                                            />
                                        </StyledTableCell>
                                        
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isInSap}
                                                name="isInSap"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isInSap', checked)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isPass}
                                                name="isPass"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isPass', checked)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isIncomplete}
                                                name="isIncomplete"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isIncomplete', checked)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isDefault}
                                                name="isDefault"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isDefault', checked)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <Switch
                                                disabled={!!(rowToEdit && rowToEdit > 0)}
                                                checked={newGrdSystemDetail.isDrop}
                                                name="isDrop"
                                                color="primary"
                                                onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isDrop', checked)}
                                            />
                                        </StyledTableCell>
                                        
                                        <StyledTableCell colSpan={1}>
                                            
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                            <IconButton disabled={!!(rowToEdit && rowToEdit > 0)} onClick={() => onComponentSave(0)}>
                                                <SaveIcon />
                                            </IconButton>
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={1}>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    {isLoading ?
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={18} className={classes.preLoaderCell}>
                                                <CircularProgress />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        : grdSystemDetail.map((grdBKComp, index) => (
                                            <StyledTableRow key={`row-${index}`}>
                                                
                                                <StyledTableCell colSpan={1} key={`grade-${index + 1}`}>
                                                    <InputField
                                                        type={InputType.TEXT}
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        id={`grade[${index + 1}]`}
                                                        name={`grade[${index + 1}]`}
                                                        key={`gradeValue-${index + 1}`}
                                                        defaultValue={grdBKComp.grade}
                                                        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                                            handleNewComponentFieldChange("grade", e.target.value, index + 1);
                                                        }}
                                                        error={!!(data.errors.grade && data.errors.grade[index + 1])}
                                                        inputProps={{ maxLength: 5 }}
                                                        helperText={
                                                            (data.errors.grade && data.errors.grade[index + 1])
                                                                ? (data.errors.grade[index + 1] as FieldError).message
                                                                : undefined
                                                        }
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`gpa-${index + 1}`}>
                                                    <InputField
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        decimal
                                                        key={`gpa-${index + 1}`}
                                                        type={InputType.NUMBER}
                                                        id={`gpa[${index + 1}]`}
                                                        name={`gpa[${index + 1}]`}
                                                        defaultValue={grdBKComp.gpa}
                                                        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                                            handleNewComponentFieldChange("gpa", e.target.value, index + 1);
                                                        }}
                                                        error={!!(data.errors.gpa && data.errors.gpa[index + 1])}
                                                        inputRef={data.register({ required: true })}
                                                        helperText={
                                                            (data.errors.gpa && data.errors.gpa[index + 1])
                                                                ? (data.errors.gpa[index + 1] as FieldError).message
                                                                : undefined
                                                        }
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isCreditsEarnedColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isCreditsEarned-${index + 1}`}
                                                        checked={grdBKComp.isCreditsEarned}
                                                        name={`isCreditsEarned-${index + 1}`}
                                                        id={`isCreditsEarned-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isCreditsEarned', checked, index + 1)}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isCreditsAttemptedColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isCreditsAttempted-${index + 1}`}
                                                        checked={grdBKComp.isCreditsAttempted}
                                                        name={`isCreditsAttempted-${index + 1}`}
                                                        id={`isCreditsAttempted-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isCreditsAttempted', checked, index + 1)}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isTransferGradeColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isTransferGrade-${index + 1}`}
                                                        checked={grdBKComp.isTransferGrade}
                                                        name={`isTransferGrade-${index + 1}`}
                                                        id={`isTransferGrade-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isTransferGrade', checked, index + 1)}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isInGpaColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isInGpa-${index + 1}`}
                                                        checked={grdBKComp.isInGpa}
                                                        name={`isInGpa-${index + 1}`}
                                                        id={`isInGpa-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isInGpa', checked, index + 1)}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isInSapColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isInSap-${index + 1}`}
                                                        checked={grdBKComp.isInSap}
                                                        name={`isInSap-${index + 1}`}
                                                        id={`isInSap-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isInSap', checked, index + 1)}
                                                    />
                                                    
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isPassColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isPass-${index + 1}`}
                                                        checked={grdBKComp.isPass}
                                                        name={`isPass-${index + 1}`}
                                                        id={`isPass-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isPass', checked, index + 1)}
                                                    />
                                                    
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isIncompleteColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isIncomplete-${index + 1}`}
                                                        checked={grdBKComp.isIncomplete}
                                                        name={`isIncomplete-${index + 1}`}
                                                        id={`isIncomplete-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isIncomplete', checked, index + 1)}
                                                    />
                                                    
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isDefaultColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isDefault-${index + 1}`}
                                                        checked={grdBKComp.isDefault}
                                                        name={`isDefault-${index + 1}`}
                                                        id={`isDefault-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isDefault', checked, index + 1)}
                                                    />
                                                    
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`isDropColumn-${index + 1}`}>
                                                    <Switch
                                                        disabled={!rowToEdit || rowToEdit !== (index + 1)}
                                                        key={`isDrop-${index + 1}`}
                                                        checked={grdBKComp.isDrop}
                                                        name={`isDrop-${index + 1}`}
                                                        id={`isDrop-${index + 1}`}
                                                        color="primary"
                                                        onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleNewComponentFieldChange('isDrop', checked, index + 1)}
                                                    />
                                                    
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`grdSysDetailId-${index + 1}`}>
                                                
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`saveColumn-${index + 1}`}>
                                                    <IconButton disabled={!!(rowToEdit && rowToEdit !== (index + 1))} key={`saveButton-${index + 1}`} onClick={() => (rowToEdit && rowToEdit === (index + 1)) ? onComponentSave(index + 1) : setRowToEdit(index + 1)}>
                                                        {(rowToEdit && rowToEdit === (index + 1) &&
                                                            <SaveIcon key={`saveIcon-${index + 1}`} />)
                                                            ||
                                                            <EditIcon key={`editIcon-${index + 1}`} />
                                                        }
                                                    </IconButton>
                                                </StyledTableCell>
                                                <StyledTableCell colSpan={1} key={`deleteColumn-${index + 1}`}>
                                                    <IconButton disabled={!!(rowToEdit && rowToEdit !== (index + 1))} key={`deleteButton-${index + 1}`} onClick={() => !!(rowToEdit && rowToEdit === (index + 1)) ? onComponentCancel() : onComponentDelete(index)}>
                                                        {(rowToEdit && rowToEdit === (index + 1) &&
                                                            <ClearIcon key={`clearIcon-${index + 1}`} />)
                                                            ||
                                                            <DeleteIcon key={`deleteIcon-${index + 1}`} />
                                                        }
                                                    </IconButton>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                   
            </form>
        </FormContext>
        </div>
    );
};

export default GradeSystemDetailGrid;
